import { Badge } from "@/components/ui/badge";
import { failureView, type FailureFields } from "@/lib/failureClass";

/** The failure class of a failed/cancelled job as a chip, with the one-line
 *  cause under it (`cause`) — nothing for a job with no verdict. Used on the
 *  Logs list, the sibling lists and the Registry attempt rows. */
export function FailureChip({
  job,
  cause = true,
  className,
}: {
  job: FailureFields;
  /** Show the one-line cause under the chip. */
  cause?: boolean;
  className?: string;
}) {
  const v = failureView(job);
  if (!v) return null;
  return (
    <span
      className={`inline-flex flex-col items-start gap-0.5 ${className ?? ""}`}
    >
      <Badge
        variant={v.tone}
        className="cursor-help whitespace-nowrap"
        title={v.title}
        data-testid="failure-chip"
        data-failure-class={v.id}
      >
        {v.label}
      </Badge>
      {cause && v.cause && (
        <span
          className="max-w-full break-words text-xs text-muted-foreground"
          data-testid="failure-cause"
          title={v.cause}
        >
          {v.cause}
        </span>
      )}
    </span>
  );
}
